import { client } from './client';

// --- Invite Codes ---

export const getInviteCodesCanCreate = async () => {
    const response = await client.get('/v1/invite-codes/can-create');
    return response.data;
};

export const getInviteCodes = async () => {
    const response = await client.get('/v1/invite-codes');
    return response.data?.items ?? response.data;
};

export const createInviteCode = async () => {
    const response = await client.post('/v1/invite-codes');
    return response.data;
};

export const deleteInviteCode = async (uid) => {
    const response = await client.delete(`/v1/invite-codes/${uid}`);
    return response.data;
};
